import React, { useState, useEffect } from 'react';
import { AbsoluteFill, Img } from 'remotion';
import { BackgroundConfig } from '../../types/manifest';
import { Z_INDEX } from '../../constants';

interface BackgroundLayerProps {
  config: BackgroundConfig;
}

export const BackgroundLayer: React.FC<BackgroundLayerProps> = ({ config }) => {
  const [imageError, setImageError] = useState(false);
  
  // Reset error state when imageUrl changes
  useEffect(() => {
    setImageError(false);
  }, [config.imageUrl]);
  
  const baseStyle: React.CSSProperties = {
    position: 'absolute',
    inset: 0,
    zIndex: Z_INDEX.BACKGROUND,
  };

  switch (config.type) {
    case 'color':
      return (
        <AbsoluteFill
          style={{ ...baseStyle, backgroundColor: config.color || '#000000' }}
        />
      );

    case 'image':
      if (!config.imageUrl || imageError) {
        return (
          <AbsoluteFill style={{ ...baseStyle, backgroundColor: '#1a1a2e' }} />
        );
      }
      
      // For local paths (starting with /), use regular img tag
      // Remotion's Img component may have issues with local paths
      if (config.imageUrl.startsWith('/')) {
        return (
          <AbsoluteFill style={baseStyle}>
            <img
              src={config.imageUrl}
              onError={() => setImageError(true)}
              style={{
                width: '100%',
                height: '100%',
                objectFit: config.imageFit || 'cover',
              }}
              alt=""
            />
          </AbsoluteFill>
        );
      }
      
      // For S3/external URLs, use Remotion's Img
      return (
        <AbsoluteFill style={baseStyle}>
          <Img
            src={config.imageUrl}
            onError={() => setImageError(true)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: config.imageFit || 'cover',
            }}
          />
        </AbsoluteFill>
      );

    case 'gradient':
      return (
        <>
          <AbsoluteFill
            style={{ ...baseStyle, backgroundColor: '#000000' }}
          />
          <AbsoluteFill
            style={{ ...baseStyle, background: config.gradient || '#000000' }}
          />
        </>
      );

    default:
      return (
        <AbsoluteFill style={{ ...baseStyle, backgroundColor: '#1a1a2e' }} />
      );
  }
};
